import {AppState} from "../store";

export const getPipelineSettlementPageCriteria = (state: AppState) => state.pipelineSettlementPage.criteria
